import { Observable } from 'rxjs';
import { Result } from '../models/http-response.model';

export interface IRequestOption {
  readonly method:
    | 'get'
    | 'GET'
    | 'delete'
    | 'DELETE'
    | 'head'
    | 'HEAD'
    | 'options'
    | 'OPTIONS'
    | 'post'
    | 'POST'
    | 'put'
    | 'PUT'
    | 'patch'
    | 'PATCH'
    | 'purge'
    | 'PURGE'
    | 'link'
    | 'LINK'
    | 'unlink'
    | 'UNLINK';
  readonly url: string;
  readonly headers?: { [header: string]: string | string[] };
  readonly body?: any;
}

export enum HttpClientEvent {
  UNAUTHORIZED = 'Unauthorized',
}

export abstract class HttpClientAdapter {
  abstract event$: Observable<HttpClientEvent>;

  abstract request<T>(
    requestOption: IRequestOption
  ): Observable<Result<T, any>>;
}
